import React from 'react'
import styled from 'styled-components'

export const STATUS_DOT = {
  ACTIVE: 'active',
  ERROR: 'error',
  WARNING: 'warning',
  INACTIVE: 'inactive',
}

const MAP_STATUS_DOT_COLOR = {
  [STATUS_DOT.ACTIVE]: '#00C875',
  [STATUS_DOT.ERROR]: '#E44258',
  [STATUS_DOT.WARNING]: '#FFA800',
  [STATUS_DOT.INACTIVE]: '#AAABBB',
}

const DotHandler = styled.div`
  &::before {
    display: block;
    content: ' ';
    width: 8px;
    height: 8px;
    ${({ size }) =>
      size === 'small' &&
      `
  width: 6px;
  height: 6px
  `}
    margin-right: 8px;
    border-radius: 50%;
    background-color: ${({ status }) => MAP_STATUS_DOT_COLOR[status]};
  }
`

const StatusDot = ({ id = 'status-dot-id', size = 'default', status = 'inactive' }) => (
  <DotHandler id={id} size={size} status={status} />
)

export default StatusDot
